const observerOptions = {
  root: null,
  rootMargin: '0px',
  threshold: 0.1
};

const handleIntersect = (entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  const observer = new IntersectionObserver(handleIntersect, observerOptions);
  document.querySelectorAll('[data-animate]').forEach(el => {
    observer.observe(el);
  });
});
